import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = "EUR") {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency,
  }).format(amount);
}

export function formatDate(date, options = {}) {
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat("es-ES", {
    dateStyle: "medium",
    ...options,
  }).format(d);
}

export function formatDateTime(date) {
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat("es-ES", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(d);
}

export function formatPercentage(value) {
  return `${value.toFixed(1)}%`;
}

export function getInitials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export function truncate(str, length = 50) {
  if (!str) return "";
  if (str.length <= length) return str;
  return str.slice(0, length) + "...";
}

export function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-");
}

export const businessTypes = [
  { value: "restaurant", label: "Restaurante" },
  { value: "bar", label: "Bar" },
  { value: "cafeteria", label: "Cafetería" },
  { value: "dark_kitchen", label: "Dark Kitchen" },
  { value: "food_truck", label: "Food Truck" },
];

export const cuisineTypes = [
  { value: "spanish", label: "Española" },
  { value: "mediterranean", label: "Mediterránea" },
  { value: "italian", label: "Italiana" },
  { value: "mexican", label: "Mexicana" },
  { value: "venezuelan", label: "Venezolana" },
  { value: "colombian", label: "Colombiana" },
  { value: "asian", label: "Asiática" },
  { value: "japanese", label: "Japonesa" },
  { value: "american", label: "Americana" },
  { value: "fusion", label: "Fusión" },
  { value: "tapas", label: "Tapas" },
  { value: "vegetarian", label: "Vegetariana" },
  { value: "other", label: "Otra (especificar)" },
];

export const priceRanges = [
  { value: "low", label: "Económico (€)" },
  { value: "medium", label: "Medio (€€)" },
  { value: "high", label: "Premium (€€€)" },
];

export const units = [
  { value: "kg", label: "Kilogramos (kg)" },
  { value: "g", label: "Gramos (g)" },
  { value: "l", label: "Litros (l)" },
  { value: "ml", label: "Mililitros (ml)" },
  { value: "units", label: "Unidades" },
];
